module.exports = __webpack_public_path__ + "img/image.b09a8f7f.svg";